import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import axios from "axios/index";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import {AxiosHeader} from "../../functions/GlobalFunctions";

class DropDownAppCategory extends Component {


    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            loading: true,
            appCategory: []
        };
    }

    handleSelect(value) {
        this.props.handlerFromParent(value);
    }

    componentDidMount() {

        if (AxiosHeader.getConfig() !== null) {

            const url = process.env.REACT_APP_API_URL + "/Application/categories";

            axios
                .get(url,AxiosHeader.getConfig())
                .then(res => {
                    const appCategory = res.data;
                    const loading = false;
                    this.setState({appCategory, loading});
                })
                .catch(error => {
                    this.setState({loading: false});
                    console.log(error);
                    //this.props.dispatch(userActions.logoutUnauthorized());
                });
        }else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

    }

    render() {
        return (
            <Select
                placeholder="Category Select"
                name="categorySelect"
                autoFocus={false}
                multi={false}
                isSearchable={true}
                disabled={this.props.disabled}
                value={this.props.categorySelected}
                options={this.state.appCategory}
                onChange={value => this.handleSelect(value)}

            />
        );
    }

}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDropDownAppCategory = connect(mapStateToProps)(DropDownAppCategory);
const connectedDropDownAppCategoryTrans = withNamespaces('common')(connectedDropDownAppCategory);
export {connectedDropDownAppCategoryTrans as DropDownAppCategory};
